import {
  GET_GIFT_INFORMATIONS_REQUEST,
  GET_GIFT_INFORMATIONS_SUCCESS,
  GET_GIFT_INFORMATIONS_FAILURE,
  GET_CITIES_TEAMS_REQUEST,
  GET_CITIES_TEAMS_SUCCESS,
  GET_CITIES_TEAMS_FAILURE,
  GET_GIFT_AGREEMENT_REQUEST,
  GET_GIFT_AGREEMENT_SUCCESS,
  GET_GIFT_AGREEMENT_FAILURE,
  UPDATE_GIFT_INFORMATIONS_REQUEST,
  UPDATE_GIFT_INFORMATIONS_SUCCESS,
  UPDATE_GIFT_INFORMATIONS_FAILURE
} from 'Store/constants';

const genderOptions = [
  {
    key: 'U',
    value: 'Belirtmek İstemiyorum'
  },
  {
    key: 'F',
    value: 'Kadın'
  },
  {
    key: 'M',
    value: 'Erkek'
  }
];

const sizeOptions = [
  {
    key: 'U',
    value: 'Belirtmek İstemiyorum'
  },
  {
    key: 'XS',
    value: 'XS Beden'
  },
  {
    key: 'S',
    value: 'S Beden'
  },
  {
    key: 'M',
    value: 'M Beden'
  },
  {
    key: 'L',
    value: 'L Beden'
  },
  {
    key: 'XL',
    value: 'XL Beden'
  },
  {
    key: 'XXL',
    value: 'XXL Beden'
  }
];

const initialState = {
  data: {},
  isLoading: false,
  error: null,
  options: {
    sizeList: sizeOptions,
    genderList: genderOptions,
    teamList: [{ key: 0, value: 'Belirtmek İstemiyorum' }],
    cityList: [{ key: 0, value: 'Belirtmek İstemiyorum' }]
  }
};

export default (state = initialState, action) => {
  switch (action.type) {

    case GET_GIFT_INFORMATIONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_GIFT_INFORMATIONS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_GIFT_INFORMATIONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_CITIES_TEAMS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_CITIES_TEAMS_SUCCESS:
      return {
        ...state,
        options: {
          ...state.options,
          teamList: initialState.options.teamList.concat(action.payload.teams),
          cityList: initialState.options.cityList.concat(action.payload.cities)
        },
        isLoading: false,
        error: null
      };
    case GET_CITIES_TEAMS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_GIFT_AGREEMENT_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_GIFT_AGREEMENT_SUCCESS:
      return { ...state, agreement: action.payload, isLoading: false, error: null };
    case GET_GIFT_AGREEMENT_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case UPDATE_GIFT_INFORMATIONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case UPDATE_GIFT_INFORMATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null
      };
    case UPDATE_GIFT_INFORMATIONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    default:
      return state;
  }
  

};
